module.exports = __webpack_public_path__ + "img/9788983926845.ed37b644.jpg";